import { Component, h } from '@stencil/core';

@Component({
    tag: 'rentware-divider',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareDivider {
    render() {
        return (
            <div class="Divider">
                <div class="Line" />
            </div>
        )
    }
}
